import React from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Card, 
  CardContent, 
  Grid,
  Paper
} from '@mui/material';
import { 
  Business as BusinessIcon,
  People as PeopleIcon,
  Settings as SettingsIcon,
  NavigateNext as NavigateNextIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const CreateFirstOrganization: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <Paper sx={{ p: 4, borderRadius: 2, mb: 4 }}>
      <Typography variant="h5" align="center" gutterBottom>
        Welcome to MentoringFusion!
      </Typography>
      <Typography variant="body1" align="center" paragraph sx={{ mb: 4 }}>
        Get started by creating your first organization. Organizations are the foundation
        of your mentorship programs, representing your company, nonprofit, or community.
      </Typography>
      
      <Grid container spacing={4} sx={{ mb: 4 }}>
        <Grid item xs={12} md={4}>
          <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <CardContent sx={{ flexGrow: 1 }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                <BusinessIcon sx={{ fontSize: 40, color: 'primary.main' }} />
              </Box>
              <Typography gutterBottom variant="h6" component="h2" align="center">
                Organization Profile
              </Typography>
              <Typography variant="body2" align="center">
                Define your organization's mission, vision, and purpose.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <CardContent sx={{ flexGrow: 1 }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                <PeopleIcon sx={{ fontSize: 40, color: 'primary.main' }} />
              </Box>
              <Typography gutterBottom variant="h6" component="h2" align="center">
                Add Team Members
              </Typography>
              <Typography variant="body2" align="center">
                Invite administrators and team members to help manage your mentorship programs.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <CardContent sx={{ flexGrow: 1 }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                <SettingsIcon sx={{ fontSize: 40, color: 'primary.main' }} />
              </Box>
              <Typography gutterBottom variant="h6" component="h2" align="center">
                Organization Settings
              </Typography>
              <Typography variant="body2" align="center">
                Configure preferences, branding, and access controls for your organization.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Button 
          variant="contained" 
          size="large" 
          endIcon={<NavigateNextIcon />}
          onClick={() => navigate('/organizations/new')}
        >
          Create Your Organization
        </Button>
      </Box>
    </Paper>
  );
};

export default CreateFirstOrganization;
